import { EMPTY_SCOPE_DEFINITION, MOQ_FACET_KEY, MOQ_FACET_VALUE } from '../constants';
import { Attribute } from '../clients/DiscoveryPagesService';
import { MsxProduct } from '../clients/MsxService';
import { ApplicationState, TagSelection } from '../model/ApplicationState';
import { Category } from '../model/Category';
import { AttributeFilter, CategoryFilter, FacetFilter, ProductFilter, ScopeDefinition } from '../model/ScopeDefinition';
import { toMetadataKey } from '../helper/tagKeyConverter';

export const mapToScopeDefinition = (applicationState: ApplicationState): ScopeDefinition => {
  try {
    const scopeDefinition: ScopeDefinition = {
      default: {
        categories: applicationState.categories.map(mapCategory),
        products: applicationState.products.map(mapProduct),
        attributes: applicationState.attributes.map(mapAttribute),
        facets: [
          ...applicationState.tags.map(mapTagToFacet),
          ...(applicationState.moq ? [{ key: MOQ_FACET_KEY, value: MOQ_FACET_VALUE }] : []),
        ],
        useOldScope: applicationState.useOldScope,
        useCsvProductInput: applicationState.useCsvProductInput,
      },
    };
    return scopeDefinition;
  } catch {
    console.warn('Error mapping scope definiton, returning empty application state');
    return EMPTY_SCOPE_DEFINITION;
  }
};

const mapCategory = (category: Category): CategoryFilter => {
  return {
    categoryId: category.id,
  };
};

const mapProduct = (product: MsxProduct): ProductFilter => {
  return {
    key: 'mpvId',
    value: product.mpvId,
  };
};

const mapAttribute = (attribute: Attribute): AttributeFilter => {
  return {
    key: attribute.name,
    selectedValues: attribute.values,
  };
};

const mapTagToFacet = (tag: TagSelection): FacetFilter => {
  return {
    key: toMetadataKey(tag.name),
    value: tag.value,
  };
};
